import {FC} from 'react';
import {useRecoilValue} from 'recoil';

import {Box, Divider, Stack, SxProps, Typography} from '@mui/material';
import CameraAltOutlinedIcon from '@mui/icons-material/CameraAltOutlined';
import VideocamOutlinedIcon from '@mui/icons-material/VideocamOutlined';
import KeyboardVoiceOutlinedIcon from '@mui/icons-material/KeyboardVoiceOutlined';
import AttachFileOutlinedIcon from '@mui/icons-material/AttachFileOutlined';
import {colors} from '../../../../shared/colors';
import {serviceRequestActiveTabState} from '../../../../store/service-requests/atoms';
import {IDocument} from '../../../../shared/types/document.types';
import {WorkDataMedia} from './WorkDataMedia';
import {InputTypeEnum} from '../../../../shared/types/workContent.types';
import {WorkDataAudio} from './WorkDataAudio';
import {WorkDataFiles} from './WorkDataFiles';

interface IWorkDataMultiple {
  item: {
    files?: IDocument[];
    text: string;
    formName: string;
    mandatory?: boolean;
    maxFilesAllowed?: number;
  };
  isEditable: boolean;
}

const STYLES = {
  ICON_CONTAINER: {
    maxWidth: '45px',
    width: '100%',
    height: '45px',
    backgroundColor: '#b9b9b9',
    borderRadius: '50px',
    textAlign: 'center',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
} as const satisfies SxProps;

export const WorkDataMultiple: FC<IWorkDataMultiple> = ({item, isEditable}) => {
  const activeTab = useRecoilValue(serviceRequestActiveTabState);

  return (
    <Box sx={{p: 2.5, border: '1px solid #b9b9b9', borderRadius: '14px'}}>
      <Stack direction="column" spacing={1}>
        <Typography
          sx={{color: colors['icons--primary'], width: 'fit-content', maxWidth: activeTab?.editMode ? 290 : 320}}
          textOverflow="ellipsis"
          noWrap
          variant="subtitle2"
        >
          {item.text}
        </Typography>
        <Divider orientation="horizontal" flexItem />
        <Stack direction="row" spacing={2.5}>
          <Box sx={STYLES.ICON_CONTAINER}>
            <CameraAltOutlinedIcon sx={{fontSize: '28px'}} htmlColor="#fff" />
          </Box>
          <WorkDataMedia
            item={item}
            isEditable={isEditable}
            isTextVisible={false}
            mediaType={InputTypeEnum.IMAGE}
            isMultipleInput
          />
        </Stack>
        <Divider orientation="horizontal" flexItem />
        <Stack direction="row" spacing={2.5}>
          <Box sx={STYLES.ICON_CONTAINER}>
            <VideocamOutlinedIcon sx={{fontSize: '28px'}} htmlColor="#fff" />
          </Box>
          <WorkDataMedia
            item={item}
            isEditable={isEditable}
            isTextVisible={false}
            mediaType={InputTypeEnum.VIDEO}
            isMultipleInput
          />
        </Stack>
        <Divider orientation="horizontal" flexItem />
        <Stack direction="row" spacing={2.5}>
          <Box sx={STYLES.ICON_CONTAINER}>
            <KeyboardVoiceOutlinedIcon sx={{fontSize: '28px'}} htmlColor="#fff" />
          </Box>
          <WorkDataAudio item={item} isEditable={isEditable} isTextVisible={false} />
        </Stack>
        <Divider orientation="horizontal" flexItem />
        <Stack direction="row" spacing={2.5}>
          <Box sx={STYLES.ICON_CONTAINER}>
            <AttachFileOutlinedIcon sx={{fontSize: '28px'}} htmlColor="#fff" />
          </Box>
          <WorkDataFiles item={item} isEditable={isEditable} isTextVisible={false} isMultipleInput />
        </Stack>
      </Stack>
    </Box>
  );
};
